"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const common_components_1 = require("@zapier/common-components");
const design_system_1 = require("@zapier/design-system");
const theme_1 = require("@zapier/theme");
const CustomMapperStyles_1 = __importDefault(require("./CustomMapperStyles"));
const ChoiceGroupHeader = ({ group, isOpen, onClick, onKeyDown, }) => {
    return (common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.choiceGroup, onClick: onClick, onKeyDown: onKeyDown, role: "button", tabIndex: 0 },
        common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.choiceGroupLabel },
            common_utils_1.isolateComponent(common_components_1.LogoImage, { app: group.selectedApi, border: true, borderPadding: 4, borderRadius: 8, size: 20 }),
            common_utils_1.isolateComponent(design_system_1.Spacer, { width: theme_1.Spacing.small }),
            common_utils_1.isolateComponent("span", { css: CustomMapperStyles_1.default.choiceGroupLabelText },
                group.stepNumber,
                ". ",
                group.label)),
        common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.choiceGroupArrow },
            common_utils_1.isolateComponent(common_components_1.AccordionArrow, { isOpen: isOpen }))));
};
exports.default = ChoiceGroupHeader;
